import GasCylinderOwnersFundTool from './GasCylinderOwnersFundTool';

const TOOLS = [
  {
    fixType: 'gas_exchange_purchase_owners_fund_align',
    findingType: 'gas_exchange_purchase_owners_fund_align',
    title: 'Gas purchases — remove legacy Product Stock Up',
    description:
      'Finds purchase bills that still have obsolete Product Stock Up / GST Adjustment on the profit report. Current model: purchases are balance-sheet only (Dr/Cr stock + payment). NF stock-up vendor payment is preserved.',
    scanLabel: 'Scan purchase bills for legacy P&L rows',
    applyLabel: 'Remove legacy purchase alignment rows',
    emptyMessage: 'No legacy gas purchase Product Stock Up rows in this date range.',
    removesRows: true,
  },
  {
    fixType: 'gas_exchange_owners_fund_align',
    findingType: 'gas_exchange_owners_fund_align',
    title: 'Gas exchange sales — remove legacy Product Stock Up',
    description:
      'Finds customer exchange sales with obsolete Cr Product Stock Up on the profit report (not trading income). New saves use COGS/sale plus empty stock on balance sheet only.',
    scanLabel: 'Scan exchange sales for legacy P&L rows',
    applyLabel: 'Remove legacy exchange sale Product Stock Up rows',
    emptyMessage: 'No legacy gas exchange sale Product Stock Up rows in this date range.',
    removesRows: true,
  },
  {
    fixType: 'cylinder_purchase_payment_status_align',
    findingType: 'cylinder_purchase_payment_status',
    title: 'Gas purchases — approve payment ledger status',
    description:
      'Vendor/cash payment credits saved as ACTIVE are excluded from Owners Fund while stock debits are approved. Updates status to AC_AFTER_APR only — amounts unchanged.',
    scanLabel: 'Scan purchase payment rows',
    applyLabel: 'Approve cylinder purchase payment rows',
    emptyMessage: 'All cylinder purchase payment rows already use AC_AFTER_APR.',
    removesRows: false,
  },
  {
    fixType: 'gas_full_sale_owners_fund_align',
    findingType: 'gas_full_sale_owners_fund_align',
    title: 'Full-cylinder sales — GST alignment (adds row)',
    description:
      'Full-cylinder sales with Sale Return GST / GSTPAID on balance sheet but no GST Adjustment on profit report. Adds the matching P&L debit so Owners Fund reconciles.',
    scanLabel: 'Scan full-cylinder sales for GST gap',
    applyLabel: 'Add GST Adjustment rows',
    emptyMessage: 'No full-cylinder sale GST alignment fixes needed in this date range.',
    removesRows: false,
  },
  {
    fixType: 'gas_cylinder_orphan_ledger_cleanup',
    findingType: 'gas_cylinder_orphan_ledger',
    title: 'Orphan gas ledger rows',
    description:
      'Ledger rows left behind after a gas purchase or sale bill was deleted. Causes balance sheet stock drift. Preview each row, apply removes them, Fix history supports undo.',
    scanLabel: 'Scan for orphan gas ledger rows',
    applyLabel: 'Remove orphan gas ledger rows',
    emptyMessage: 'No orphan gas ledger rows in this date range.',
    removesRows: true,
    risk: 'Medium risk — preview first',
  },
];

export default function GasCylinderOwnersFundPanel({
  pumpId,
  fromDate,
  toDate,
  disabled = false,
  onPreviewStart,
  onPreviewEnd,
  onApplyStart,
  onApplyEnd,
  onCompleted,
  onOpenHistory,
}) {
  return (
    <div className="admin-panel gas-cylinder-owners-fund-panel">
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h5 className="mb-1">Gas cylinder — integrity &amp; cleanup tools</h5>
          <p className="small text-muted mb-0">
            Run <strong>Check my accounts</strong> above first. Then scan, preview (before / after), apply, and undo gas fixes here.
            Every apply saves who, when, why, and row-level changes in Fix history.
          </p>
        </div>
        {onOpenHistory && (
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onOpenHistory} disabled={disabled}>
            Fix history &amp; undo
          </button>
        )}
      </div>

      <div className="admin-alert-item info mb-3">
        <p className="small mb-0">
          <strong>Current model:</strong> Gas purchases and exchange sales do <em>not</em> post Product Stock Up on the profit report.
          Remove legacy adjustment rows if scan flags them. Full-cylinder sales may still need GST Adjustment on P&amp;L (valid fix — adds row).
        </p>
      </div>

      {TOOLS.map((tool) => (
        <GasCylinderOwnersFundTool
          key={tool.fixType}
          pumpId={pumpId}
          fromDate={fromDate}
          toDate={toDate}
          disabled={disabled}
          onPreviewStart={onPreviewStart}
          onPreviewEnd={onPreviewEnd}
          onApplyStart={onApplyStart}
          onApplyEnd={onApplyEnd}
          onCompleted={onCompleted}
          {...tool}
        />
      ))}

      <p className="small text-muted mb-0">
        Suggested order when multiple issues appear: orphan cleanup → remove legacy purchase rows → approve payment status → exchange sale cleanup → full-cylinder GST.
      </p>
    </div>
  );
}
